import {ApplicationConfig, isDevMode, provideZoneChangeDetection} from '@angular/core';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {TranslocoHttpLoader} from './transloco-loader';
import {provideTransloco} from '@jsverse/transloco';
import {provideRouter, withRouterConfig} from '@angular/router';
import {routes} from './app.routes';
import {authInterceptor} from '@core/auth/auth.interceptor';
import {ssrForwardInterceptor} from './ssr-forward.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
        onSameUrlNavigation: 'reload'
      })
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        ssrForwardInterceptor
      ])
      // note: the fetch api does not allow progress tracking
      // withFetch()
    ),
    // {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    provideTransloco({
      config: {
        availableLangs: ['fr'],
        defaultLang: 'fr',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    })
  ]
};
